import api from './api';
import { SignupRequest, LoginRequest, AuthTokens } from '@shared/types';

export const authService = {
  signup: async (data: SignupRequest) => {
    const response = await api.post('/auth/signup', data);
    return response.data.data;
  },

  login: async (data: LoginRequest) => {
    const response = await api.post('/auth/login', data);
    return response.data.data;
  },

  refreshToken: async (refreshToken: string): Promise<AuthTokens> => {
    const response = await api.post('/auth/refresh', { refreshToken });
    return response.data.data;
  },

  requestPasswordReset: async (email: string) => {
    const response = await api.post('/auth/request-reset', { email });
    return response.data;
  },

  validateResetToken: async (token: string) => {
    const response = await api.get(`/auth/validate-reset?token=${token}`);
    return response.data.data;
  },

  resetPassword: async (token: string, newPassword: string) => {
    const response = await api.post('/auth/reset-password', { token, newPassword });
    return response.data;
  },

  changePassword: async (currentPassword: string, newPassword: string) => {
    const response = await api.post('/auth/change-password', {
      currentPassword,
      newPassword,
    });
    return response.data;
  },
};
